import Vue from 'vue'
import App from './App.vue'
import Axios from './axios'
import { Navbar, TabItem, TabContainer, TabContainerItem, Lazyload, Popup, Actionsheet} from 'mint-ui';
import $ from './assets/jquery-1.7.1.js'
import './assets/jquery.lazyload.js'
import 'mint-ui/lib/style.css'
import './assets/globle.css'
import router from './router'
import '@/assets/iconfont/icomoon.css'
import store from './store'
import preview from 'vue-photo-preview'
import 'vue-photo-preview/dist/skin.css'
import VueTouch from 'vue-touch'
// import VConsole from 'vconsole'
//
// new VConsole()
Vue.use(preview);
Vue.component(Navbar.name, Navbar);
Vue.component(TabItem.name, TabItem);
Vue.component(TabContainer.name, TabContainer);
Vue.component(TabContainerItem.name, TabContainerItem);
Vue.component(Popup.name, Popup);
Vue.component(Actionsheet.name, Actionsheet);
Vue.use(VueTouch, {name: 'v-touch'});
Vue.use(Lazyload, {
  loading:'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzMiAzMiIgd2lkdGg9IjMyIiBoZWlnaHQ9IjMyIiBmaWxsPSJ3aGl0ZSI+CiAgPHBhdGggb3BhY2l0eT0iLjI1IiBkPSJNMTYgMCBBMTYgMTYgMCAwIDAgMTYgMzIgQTE2IDE2IDAgMCAwIDE2IDAgTTE2IDQgQTEyIDEyIDAgMCAxIDE2IDI4IEExMiAxMiAwIDAgMSAxNiA0Ii8+CiAgPHBhdGggZD0iTTE2IDAgQTE2IDE2IDAgMCAxIDMyIDE2IEwyOCAxNiBBMTIgMTIgMCAwIDAgMTYgNHoiPgogICAgPGFuaW1hdGVUcmFuc2Zvcm0gYXR0cmlidXRlTmFtZT0idHJhbnNmb3JtIiB0eXBlPSJyb3RhdGUiIGZyb209IjAgMTYgMTYiIHRvPSIzNjAgMTYgMTYiIGR1cj0iMC44cyIgcmVwZWF0Q291bnQ9ImluZGVmaW5pdGUiIC8+CiAgPC9wYXRoPgo8L3N2Zz4K'
});
Vue.prototype.$axios = Axios;
Vue.config.productionTip = false;
VueTouch.config.swipe = {
  threshold: 50 //手指左右滑动距离
};

// 返回
Vue.prototype.goBack = (route) => {
  route.animate = 2;
  history.go(-1)
}

Vue.prototype.goBack2 = (route) => {
  route.animate = 2;
  history.go(-2)
}

Date.prototype.Format = function (fmt) {
  var o = {
    "M+": this.getMonth() + 1,                 //月份
    "d+": this.getDate(),                    //日
    "h+": this.getHours(),                   //小时
    "m+": this.getMinutes(),                 //分
    "s+": this.getSeconds(),                 //秒
    "q+": Math.floor((this.getMonth() + 3) / 3), //季度
    "S": this.getMilliseconds()             //毫秒
  };
  if (/(y+)/.test(fmt))
    fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
  for (var k in o)
    if (new RegExp("(" + k + ")").test(fmt))
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
  return fmt;
};

Vue.prototype.geneUserHeadBySize = function(userId, userPicture, size) {
  if (this.isEmpty(userPicture)) {
    return this.$qiNiuDomainBase + "/Head/default.png";
  }

  return this.$qiNiuDomainBase + "/" + userId + "/Head/" + userPicture + "?imageView2/1/w/" + size + "/h/" + size;
};

Vue.prototype.geneUserHead = function(userId, userPicture) {
  return this.geneUserHeadBySize(userId, userPicture, 80);
};
Vue.prototype.geneSexImage = function(sex) {
  return sex === 1 ? require('@/Images/icon_female.png') : require('@/Images/icon_male.png');
};
Vue.prototype.geneUserAudioFileName = function () {
  let d = (new Date()).Format("yyyyMMddhhmmssS");
  return this.$store.state.userid + "/WordSentenceVoice/" + d + ".mp3";
};
Vue.prototype.getProgramStarCount = function (score) {
  let vScore = parseFloat(score);
  let vStar = 0;

  if (vScore > 0.5 && vScore <= 2.0) {
    vStar = 2;
  } else if (vScore > 2.0 && vScore <= 5.0) {
    vStar = 3;
  }

  if (vStar === 0) {
    return this.getRandomInt(1, 2);
  }

  return vStar;
};
Vue.prototype.getRandomInt = function(min, max) {
  // 以下函数返回 min（包含）～ max（包含）之间的数字：
  return  Math.floor(Math.random() * (max - min + 1)) + min;
};

Vue.prototype.getProgramAudioUrl = function (star) {
  let vStar = parseFloat(star);

  if (vStar === 1) {
    return this.$qiNiuDomainBase + "one_star.mp3";
  }

  if (vStar === 2) {
    return this.$qiNiuDomainBase + "two_star.mp3";
  }

  if (vStar === 3) {
    return this.$qiNiuDomainBase + "three_star.mp3";
  }

  return this.$qiNiuDomainBase + "try_again.mp3";
};

Vue.prototype.getCourseMainColor = function (id){
  switch (id) {
    case 1:
      return "#b23536";
    case 2:
      return "#275ba9";
    case 3:
      return "#03abae";
    case 5:
      return "#34a8e1";
    default:
      return "#fafafa";
  }
};
Vue.prototype.getCourseSubColor = function (id) {
  switch (id) {
    case 1:
      return "#e1a190";
    case 2:
      return "#adc5da";
    case 3:
      return "#87d0cf";
    case 5:
      return "#adc5da";
    default:
      return "#fafafa";
  }
};
Vue.prototype.getCourseWordColor = function (id) {
  switch (id) {
    case 1:
      return "#b23536";
    case 2:
      return "#275ba9";
    case 3:
      return "#03abae";
    case 5:
      return "#34a8e1";
    default:
      return "#fafafa";
  }
};
Vue.prototype.getCourseBuyButtonColor = function (id) {
  switch (id) {
    case 1:
      return "#dd2126";
    case 2:
      return "#275ba9";
    case 3:
      return "#03abae";
    case 5:
      return "#dd2126";
    default:
      return "#fafafa";
  }
};
Vue.prototype.getSuccessCourseColor = function () {
  return "#369e54";
};
Vue.prototype.getSuccessSubCourseColor = function () {
  return "#adcd37";
};
Vue.prototype.getSuccessBuyButtonColor = function () {
  return "#b8d041";
};
Vue.prototype.getProgramCourseColor = function (id){
  return "#1C5C93";
};
Vue.prototype.getProgramCourseBGColor = function (id){
  return "#f4f4f4";
};
Vue.prototype.getProgramCourseWordColor = function (id){
  return "#efefef";
};
Vue.prototype.isEmpty = function (str) {
  return str == null || str.length === 0;
}
Vue.prototype.getCount = function (obj) {
  return obj == null ? 0 : parseInt(obj);
};
Vue.prototype.deepCopy = function (obj) {
  return JSON.parse(JSON.stringify(obj));
};
Vue.prototype.geneNetworkPicture = function (picture) {
  let that = this;

  if (picture == null) {
    return "";
  }

  if (picture.substring(0, 4) === "http") {
    return picture;
  }
  return that.$qiNiuDomainBase + picture;
};
Vue.prototype.isMobile = function () {
  let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
  return flag;
};
Vue.prototype.isWeixinBrowser = function () {
  var ua = navigator.userAgent.toLowerCase();
  if (ua.match(/MicroMessenger/i) === "micromessenger") {
    return true;
  }

  return typeof WeixinJSBridge !== "undefined";
};
Vue.prototype.realFormatSecond = function(second) {
  let secondType = typeof second;

  if (secondType === "number" || secondType === "string") {
    second = parseInt(second);

    var hours = Math.floor(second / 3600);
    second = second - hours * 3600;
    var mimute = Math.floor(second / 60);
    second = second - mimute * 60;
    return ("0" + mimute).slice(-2) + ":" + ("0" + second).slice(-2);
  } else {
    return "00:00";
  }
}
Vue.prototype.isAppIos = function () {
  let u = navigator.userAgent;
  return !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
}
Vue.prototype.isAppAndroid = function () {
  let u = navigator.userAgent;
  return u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;
}
Vue.prototype.getOriginalImage = function (filename) {
  if (this.isEmpty(filename))
  {
    return "";
  }

  if (filename.indexOf("http") === 0) {
    return filename;
  }

  return this.$qiNiuDomainBase + filename;
};
Vue.prototype.getWholeThumbnailCut = function (filename, width, height) {
  let vOriginalImage = this.getOriginalImage(filename);

  if (this.isEmpty(vOriginalImage))
  {
    return "";
  }

  return vOriginalImage + "?imageView2/1/w/" + width + "/h/" + height;
};
Vue.prototype.getCurrentDomainUrl = function () {
  return window.location.protocol + "//" + window.location.host + "/";
};

// 左右拖拽题
Vue.directive('drag',//自定义指令
    {
      bind:function (el, binding) {
        let oDiv = el;   //当前元素
        let oldTop = 0;
        let lastLeft = 0;
        let lastTop = 0;
        let optionTop = parseInt(binding.value.optionTop);
        let optionRgith = parseInt(binding.value.optionRgith);
        let optionWidth = parseInt(binding.value.optionWidth);
        let optionPadding = parseInt(binding.value.optionPadding);
        let optionBorderWidth = parseInt(binding.value.optionBorderWidth);
        let bgWidth = parseInt(binding.value.bgWidth);
        let listQuestionOption = JSON.parse(binding.value.json);

        oDiv.ontouchstart = function (e) {
          window.resetShowGuide();

          let imgQuestion = document.getElementById('question');
          let scale = imgQuestion.width / bgWidth;
          let imgId = parseInt(oDiv.id.replace(/dp_drag_/, ""));
          let objQuestionOption = listQuestionOption[imgId];
          let fillingType = parseInt(objQuestionOption.fillingType);
          let rangeWidthOrRadius = parseInt(objQuestionOption.rangeWidthOrRadius) * scale;
          let rangeHeight = parseInt(objQuestionOption.rangeHeight) * scale;

          // 填充类型（1圆形/2方形）
          if (fillingType === 1) {
            oDiv.style.width = (rangeWidthOrRadius*2) + 'px';
            oDiv.style.height = (rangeWidthOrRadius*2)  + 'px';
          } else if (fillingType === 0) {
            for (var i = 0; i < listQuestionOption.length; i++) {
              var vQuestionOption = listQuestionOption[i];

              if (parseInt(vQuestionOption.isRightAnswer) === 1) {
                let vFillingType = parseInt(vQuestionOption.fillingType);
                let vRangeWidthOrRadius = parseInt(vQuestionOption.rangeWidthOrRadius) * scale;
                let vRangeHeight = parseInt(vQuestionOption.rangeHeight) * scale;

                oDiv.style.width = (vFillingType === 1 ? vRangeWidthOrRadius*2 : vRangeWidthOrRadius) + 'px';
                oDiv.style.height = (vFillingType === 1 ? vRangeWidthOrRadius*2 : vRangeHeight) + 'px';
                break;
              }
            }
          } else {
            oDiv.style.width = rangeWidthOrRadius + 'px';
            oDiv.style.height = rangeHeight + 'px';
          }

          let dpQuestionAnswer = document.getElementById('dp_question_answer');
          let tempIds = dpQuestionAnswer.value;
          let tempIdsArray = [];

          if (tempIds.length > 0) {
            tempIdsArray = JSON.parse(tempIds);
          }

          if (tempIdsArray.indexOf(imgId) !== -1) {
            return;
          }

          if (oldTop === 0) {
            oldTop = oDiv.offsetTop;
          } else {
            let vOldTops = document.getElementById('dp_old_top');
            let vTops = vOldTops.value;

            if (vTops !== undefined && vTops !== null && vTops.length > 0) {
              let vTopsArray = JSON.parse(vTops);

              for (var j = 0; j < vTopsArray.length; j++) {
                let vItem = vTopsArray[j];

                if (vItem.key === imgId) {
                  oldTop = parseInt(vItem.value);
                }
              }

            }
          }

          //鼠标按下，计算当前元素距离可视区的距离
          let disX = e.touches[0].clientY - oDiv.offsetLeft;
          let disY = e.touches[0].clientX + oDiv.offsetTop;

          document.ontouchmove = function (e) {
            //通过事件委托，计算移动的距离
            lastLeft = e.touches[0].clientY - disX;
            lastTop = disY - e.touches[0].clientX;

            //移动当前元素
            oDiv.style.left = lastLeft + 'px';
            oDiv.style.top = lastTop + 'px';
          };
          document.ontouchend = function (e) {
            let divPrint = document.getElementById('print');
            let currentPointX = objQuestionOption.coordinateX * scale;
            let currentPointY = objQuestionOption.coordinateY * scale;

            let realLeft = divPrint.clientWidth - optionRgith - optionWidth - imgQuestion.offsetLeft - currentPointX - 2*optionPadding + optionBorderWidth;
            let realTop = 30 + imgQuestion.offsetTop + currentPointY - optionTop;

            let realMinLeft = 0;
            let realMinTop = 0;
            let realMaxLeft = 0;
            let realMaxTop = 0;
            let isOver = false;

            // 填充类型（1圆形/2方形）
            if (fillingType === 1) {
              realMinLeft = - (realLeft + rangeWidthOrRadius);
              realMinTop = realTop - rangeWidthOrRadius;
              realMaxLeft = -(realLeft - rangeWidthOrRadius);
              realMaxTop = realTop + rangeWidthOrRadius;

              isOver = (parseInt(lastLeft) > parseInt(realMinLeft - rangeWidthOrRadius) && parseInt(lastLeft + 2*rangeWidthOrRadius) < parseInt(realMaxLeft + rangeWidthOrRadius))
                  && (parseInt(lastTop) > parseInt(realMinTop - rangeWidthOrRadius) && parseInt(lastTop + 2*rangeWidthOrRadius) < parseInt(realMaxTop + rangeWidthOrRadius));
            } else {
              realMinLeft = - realLeft;
              realMinTop = realTop;
              realMaxLeft = -(realLeft - rangeWidthOrRadius);
              realMaxTop = realTop + rangeHeight;

              isOver = Math.max(parseInt(realMinLeft), parseInt(lastLeft)) <= Math.min(parseInt(realMaxLeft), (parseInt(lastLeft) + parseInt(rangeWidthOrRadius)))
                  && Math.max(parseInt(realMinTop), parseInt(lastTop)) <= Math.min(parseInt(realMaxTop), (parseInt(lastTop) + parseInt(rangeHeight)));
            }

            if (isOver) {
              oDiv.style.left = realMinLeft + 'px';
              oDiv.style.top = realMinTop + 'px';

              // 播放音效
              const pageAudio = document.getElementById('dp_musicmp3');
              pageAudio.src = "https://img.xiaohuasheng.cn/drag_result.mp3";
              pageAudio.play();

              let vQuestionAudio = "https://img.xiaohuasheng.cn/" + objQuestionOption.audio;

              oDiv.onclick = function () {
                pageAudio.src = vQuestionAudio;
                pageAudio.play();
              }

              // 播放音频
              setTimeout(() => {
                pageAudio.src = vQuestionAudio;
                pageAudio.play();
              }, 500);

              if (tempIdsArray.indexOf(imgId) === -1) {
                tempIdsArray.push(imgId);
                dpQuestionAnswer.value = JSON.stringify(tempIdsArray);
              }

              // 判断是否完成题目
              var vCount = 0;

              for (var i = 0; i < listQuestionOption.length; i++) {
                var vQuestionOption = listQuestionOption[i];

                if (parseInt(vQuestionOption.isRightAnswer) === 1) {
                  vCount += 1;
                }
              }

              if (tempIdsArray.length === vCount) {
                // let dpAnswer = document.getElementById("dp_answer");
                // dpAnswer.style.backgroundColor = 'transparent';
                let listError = document.getElementsByClassName('answer_error');

                for (let j = 0; j < listError.length; j++) {
                  var vError = listError[j];
                  vError.style.display = "none";
                }

                let listJob = document.getElementsByClassName('cl_right_job');

                if (listJob != null && listJob.length > 0) {
                  let vJob = listJob[0];
                  vJob.style.display = '';
                }

                // 下一步
                window.successGetStarToNext();
                window.clearGuideTimeout();
              }

              // 改变选项位置
              document.getElementById('dp_reset_option_place').click();
            } else {
              oDiv.style.width = optionWidth + 'px';
              oDiv.style.height = optionWidth  + 'px';
              oDiv.style.left = 'auto';
              oDiv.style.rigth = (optionPadding - optionBorderWidth) + 'px';
              oDiv.style.top = oldTop + 'px';
            }

            document.ontouchmove = null;
            document.ontouchend = null;
          };
        };
      }
    }
);

// 大猫6拖拽题
Vue.directive('bigcat6drag',
    {
      bind:function (el, binding) {
        let oDiv = el;   //当前元素
        let oldLeft = 0;
        let oldTop = 0;
        let lastLeft = 0;
        let lastTop = 0;
        let questionType = parseInt(binding.value.questionType);
        let optionTop = parseInt(binding.value.optionTop);
        let optionRight = parseInt(binding.value.optionRight);
        let optionWidth = parseInt(binding.value.optionWidth);
        let optionHeight = parseInt(binding.value.optionHeight);
        let optionPadding = parseInt(binding.value.optionPadding);
        let optionBorderWidth = parseInt(binding.value.optionBorderWidth);
        let bgWidth = parseInt(binding.value.bgWidth);
        let listAllOption = JSON.parse(binding.value.allOption); // 所有选项排除选择后的选项
        let listOptionCoordinate = JSON.parse(binding.value.optionCoordinateJson); // 正确选项坐标
        let listSelectOption = JSON.parse(binding.value.listSelectOptionJson); //选择后的选项
        let optionCount = listSelectOption.length;

        // 单分类，多分类拖拽题参数
        let tmpRangeWidth = 0;
        let tmpRangeHeight = 0;
        let tmpRangeX = 0;
        let tmpRangeY = 0;

        // 判断当前选项是否在已经选择的选项中
        function existSelectOption(currentOption) {
          let isExist = false;

          for (let i = 0; i < listSelectOption.length; i++) {
            var itemOption = listSelectOption[i];

            if (currentOption.coordinateX === itemOption.coordinateX && currentOption.coordinateY === itemOption.coordinateY) {
              isExist = true;
            }
          }

          return isExist;
        }

        // 分类题拖拽区域识别
        function getClassIsOver(option, factX, factY, answerRangeX, answerRangeY, answerRangeWidth, answerRangeHeight, rangeWidthOrRadius, rangeHeight) {
          let divPrint = document.getElementById('print');
          let imgQuestion = document.getElementById('question');

          let realLeft = divPrint.clientWidth - optionRight - optionWidth - imgQuestion.offsetLeft - answerRangeX - 2*optionPadding + optionBorderWidth;
          let realTop = 30 + imgQuestion.offsetTop + answerRangeY - optionTop;

          let realMinLeft = - realLeft;
          let realMinTop = realTop;
          let realMaxLeft = -(realLeft - rangeWidthOrRadius);
          let realMaxTop = realTop + rangeHeight;
          let offset = Math.min(answerRangeWidth, answerRangeHeight);

          let isOver = option.isRightAnswer === 1 && Math.max(parseInt(realMinLeft), parseInt(lastLeft)) <= Math.min(parseInt(realMaxLeft), (parseInt(lastLeft) + parseInt(offset)))
              && Math.max(parseInt(realMinTop), parseInt(lastTop)) <= Math.min(parseInt(realMaxTop), (parseInt(lastTop) + parseInt(offset)));

          return {
            isOver:isOver,
            realMinLeft:-factX,
            realMinTop:factY,
            coordinateX:option.coordinateX,
            coordinateY:option.coordinateY,
            currentPointX:factX,
            currentPointY:factY
          };
        }

        // 非分类题拖拽区域识别
        function getIsOver(option, scale, fillingType, rangeWidthOrRadius, rangeHeight) {
          let divPrint = document.getElementById('print');
          let imgQuestion = document.getElementById('question');
          let currentPointX = option.coordinateX * scale;
          let currentPointY = option.coordinateY * scale;

          let realLeft = divPrint.clientWidth - optionRight - optionWidth - imgQuestion.offsetLeft - currentPointX - 2*optionPadding + optionBorderWidth;
          let realTop = 30 + imgQuestion.offsetTop + currentPointY - optionTop;

          let realMinLeft = 0;
          let realMinTop = 0;
          let realMaxLeft = 0;
          let realMaxTop = 0;
          let isOver = false;

          // 选项类型（1长方形/2正方形）
          if (fillingType === 2) {
            realMinLeft = - realLeft;
            realMinTop = realTop;
            realMaxLeft = -(realLeft - rangeWidthOrRadius);
            realMaxTop = realTop + rangeHeight;

            isOver = Math.max(parseInt(realMinLeft), parseInt(lastLeft)) <= Math.min(parseInt(realMaxLeft), (parseInt(lastLeft) + parseInt(rangeWidthOrRadius)))
                && Math.max(parseInt(realMinTop), parseInt(lastTop)) <= Math.min(parseInt(realMaxTop), (parseInt(lastTop) + parseInt(rangeHeight)));
          }

          return {
            isOver:isOver,
            realMinLeft:realMinLeft,
            realMinTop:realMinTop,
            coordinateX:option.coordinateX,
            coordinateY:option.coordinateY,
            currentPointX:currentPointX,
            currentPointY:currentPointY
          };
        }

        // 单分类，多分类拖拽逻辑(questionType-1拖拽题/2随机拖拽题/3单个分类题/4多个分类题/5顺序拖拽题)
        if (questionType === 3 || questionType === 4) {
          // 取一个正确选项的坐标及其宽高
          for (var i = 0; i < listAllOption.length; i++) {
            let vOption = listAllOption[i];

            if (vOption.isRightAnswer === 1) {
              tmpRangeWidth = vOption.rangeWidthOrRadius;
              tmpRangeHeight = vOption.rangeHeight;
              tmpRangeX = vOption.coordinateX;
              tmpRangeY = vOption.coordinateY;
              break;
            }
          }

          oldLeft = oDiv.offsetLeft;
          oldTop = oDiv.offsetTop;
        }

        oDiv.ontouchstart = function (e) {
          window.resetShowGuide();

          let imgQuestion = document.getElementById('question');
          let scale = imgQuestion.width / bgWidth;
          let imgId = parseInt(oDiv.id.replace(/dp_drag_/, ""));
          let inputTempOptionArray = document.getElementById('input_tempoption_array');
          let listQuestionOption = JSON.parse(inputTempOptionArray.value);
          let objQuestionOption = listQuestionOption[imgId];
          let fillingType = parseInt(objQuestionOption.fillingType);
          let optionOrder = parseInt(objQuestionOption.optionOrder);
          let rangeWidthOrRadius = 0;
          let rangeHeight = 0;
          let factX, factY; // 答案实际展示的x，y坐标
          let answerRangeX = 0;
          let answerRangeY = 0;
          let answerRangeWidth = 0;
          let answerRangeHeight = 0;
          let factWidth = 0;
          let factHeight = 0;
          let listClassify = [];

          // 单分类，多分类拖拽逻辑(questionType-1拖拽题/2随机拖拽题/3单个分类题/4多个分类题/5顺序拖拽题)
          if (questionType === 3 || questionType === 4) {
            let inputClAnswer = document.getElementById('input_cl_answer');
            let tempClassify = inputClAnswer.value;

            // 隐藏框有值取隐藏框的值
            if (tempClassify.length > 0) {
              listClassify = JSON.parse(tempClassify);
            } else {
              // 获取从界面上初始化的值
              listClassify = JSON.parse(binding.value.classifyJson);
            }

            // 获取同类总正确答案，当前已选择答案数
            var totalCount = 0; // 总正确答案数
            var currentCount = 0; // 已选择正确答案数

            for (var i = 0; i < listClassify.length; i++) {
              let objClassify = listClassify[i];
              totalCount = objClassify.totalCount;

              if (objClassify.x === objQuestionOption.coordinateX && objClassify.y === objQuestionOption.coordinateY) {
                currentCount = objClassify.currentCount;
                break;
              }
            }

            // 计算当前分类答案大小
            let isError = objQuestionOption.isRightAnswer === 0;
            rangeWidthOrRadius = isError ? tmpRangeWidth * scale : parseInt(objQuestionOption.rangeWidthOrRadius) * scale; // 篮子宽
            rangeHeight = isError ? tmpRangeHeight * scale : parseInt(objQuestionOption.rangeHeight) * scale; // 篮子高
            answerRangeX = isError ? tmpRangeX * scale : objQuestionOption.coordinateX * scale; // 答案落选区域x坐标
            answerRangeY = isError ? tmpRangeY * scale : objQuestionOption.coordinateY * scale; // 答案落选区域y坐标
            answerRangeWidth = rangeWidthOrRadius / 2; // 答案落选区域宽
            answerRangeHeight = rangeHeight; // 答案落选区域高
            factWidth = answerRangeWidth; // 答案实际宽
            factHeight = answerRangeHeight;
            let padding = 10;

            if (totalCount > 2) {
              // 平分成两行的N份
              let totalColumn = Math.ceil(totalCount/2.0);
              answerRangeWidth = (rangeWidthOrRadius - (totalColumn - 1)*padding)/totalColumn;
              answerRangeHeight = (rangeHeight - padding)/2;
              factHeight = factWidth*answerRangeHeight/answerRangeWidth;

              let minHeight = Math.min(factWidth, factHeight);
              factWidth = minHeight;
              factHeight =  minHeight;

              let offsetColumn = currentCount%totalColumn;
              // 区域原点x+已展示答案数宽度+单个偏移位置
              factX = answerRangeX + offsetColumn*(answerRangeWidth + padding) + (answerRangeWidth - factWidth)/2;
              // 区域原点y+(第一行是0或第二行答案高度)+单个偏移位置
              factY = (currentCount >= totalColumn ? answerRangeHeight + padding : 0) + (answerRangeHeight - factHeight)/2 + answerRangeY;
            } else {
              factWidth = totalCount === 1 ? rangeWidthOrRadius : (rangeWidthOrRadius - padding)/2;
              factHeight = factWidth*objQuestionOption.pictureHeight/objQuestionOption.pictureWidth;

              // 区域原点x+已展示答案数宽度+单个偏移位置
              factX = answerRangeX + currentCount*(answerRangeWidth + padding) + (answerRangeWidth - factWidth)/2;
              factY = (answerRangeHeight - factHeight)/2 + answerRangeY;
            }

            oDiv.style.width = factWidth + 'px';
            oDiv.style.height = factHeight + 'px';

            if (oldLeft === 0 && oldTop === 0) {
              oldLeft = oDiv.offsetLeft;
              oldTop = oDiv.offsetTop;
            }
          } else {
            rangeWidthOrRadius = parseInt(objQuestionOption.rangeWidthOrRadius) * scale;
            rangeHeight = parseInt(objQuestionOption.rangeHeight) * scale;

            // 填充类型（1圆形/2方形）
            if (fillingType === 1) {
              oDiv.style.width = (rangeWidthOrRadius*2) + 'px';
              oDiv.style.height = (rangeWidthOrRadius*2) + 'px';
            } else if (fillingType === 0) {
              for (var k = 0; k < listQuestionOption.length; k++) {
                var vQuestionOption = listQuestionOption[k];

                if (parseInt(vQuestionOption.isRightAnswer) === 1) {
                  let vFillingType = parseInt(vQuestionOption.fillingType);
                  let vRangeWidthOrRadius = parseInt(vQuestionOption.rangeWidthOrRadius) * scale;
                  let vRangeHeight = parseInt(vQuestionOption.rangeHeight) * scale;

                  oDiv.style.width = (vFillingType === 1 ? vRangeWidthOrRadius*2 : vRangeWidthOrRadius) + 'px';
                  oDiv.style.height = (vFillingType === 1 ? vRangeWidthOrRadius*2 : vRangeHeight*3/4) + 'px';
                  break;
                }
              }
            }  else {
              oDiv.style.width = rangeWidthOrRadius + 'px';
              oDiv.style.height = rangeHeight + 'px';
            }

            oldTop = oDiv.offsetTop;
          }

          //鼠标按下，计算当前元素距离可视区的距离
          let disX = e.touches[0].clientY - oDiv.offsetLeft;
          let disY = e.touches[0].clientX + oDiv.offsetTop;

          document.ontouchmove = function (e) {
            //通过事件委托，计算移动的距离
            lastLeft = e.touches[0].clientY - disX;
            lastTop = disY - e.touches[0].clientX;

            //移动当前元素
            oDiv.style.left = lastLeft + 'px';
            oDiv.style.top = lastTop + 'px';
          };

          document.ontouchend = function (e) {
            let objIsOver = {isOver:false, realMinLeft:0, realMinTop:0, coordinateX:0, coordinateY:0, currentPointX:0, currentPointY:0};
            let isClassQuestion = questionType === 3 || questionType === 4;

            // 1拖拽题/2随机拖拽题/3单个分类题/4多个分类题/5顺序拖拽题
            if (questionType === 1 || questionType === 5) {
              // 1拖拽题/5顺序拖拽题(不按顺序不能拖拽)
              objIsOver = getIsOver(objQuestionOption, scale, fillingType, rangeWidthOrRadius, rangeHeight);

              // 顺序拖拽题(不按顺序不能拖拽)
              if (questionType === 5) {
                if (optionOrder !== optionCount + 1) {
                  objIsOver.isOver = false;
                }
              }
            } else if(questionType === 2) {
              // 随机拖拽题
              for (let i = 0; i < listOptionCoordinate.length; i++) {
                let itemOption = listOptionCoordinate[i];
                let objTempIsOver = getIsOver(itemOption, scale, fillingType, rangeWidthOrRadius, rangeHeight);

                if (objTempIsOver.isOver && !existSelectOption(itemOption)) {
                  objIsOver = objTempIsOver;
                  break;
                }
              }
            } else if(isClassQuestion) {
              // 单个分类,多个分类
              objIsOver = getClassIsOver(objQuestionOption, factX, factY, answerRangeX, answerRangeY, answerRangeWidth, answerRangeHeight, rangeWidthOrRadius, rangeHeight);
            }

            if (objIsOver.isOver) {
              // 顺序拖拽题(引导问号)
              if (questionType === 5) {
                window.showOrderQuestionTip(optionOrder + 1);
              }

              oDiv.style.left = objIsOver.realMinLeft + 'px';
              oDiv.style.top = objIsOver.realMinTop + 'px';
              oDiv.hidden = true;

              // 选项类型（1长方形/2正方形）
              if (fillingType === 2) {
                let vRangeWidthOrRadius = isClassQuestion ? factWidth : rangeWidthOrRadius;
                let vRangeHeight = isClassQuestion ? factHeight : rangeHeight;

                window.selectRightOption(objQuestionOption.picture, vRangeWidthOrRadius, vRangeHeight,
                    objIsOver.currentPointX + imgQuestion.offsetLeft,
                    objIsOver.currentPointY + imgQuestion.offsetTop,
                    objQuestionOption.code, objIsOver.coordinateX, objIsOver.coordinateY);
              }

              // 播放音效
              let optioneAudio = "https://img.xiaohuasheng.cn/" + objQuestionOption.audio;
              let hasOptionAudio = objQuestionOption.audio != null && objQuestionOption.audio.length > 0;
              window.playDragSound(optioneAudio);

              if (isClassQuestion) {
                // 当前分组数量加1
                for (var j = 0; j < listClassify.length; j++) {
                  let objClassify = listClassify[j];

                  if (objClassify.x === objQuestionOption.coordinateX && objClassify.y === objQuestionOption.coordinateY) {
                    objClassify.currentCount += 1;
                    Vue.set(listClassify, j, objClassify);
                  }
                }

                let inputClAnswer = document.getElementById('input_cl_answer');
                inputClAnswer.value = JSON.stringify(listClassify);
              }

              // 判断是否完成题目
              var vCount = 0;

              for (var i = 0; i < listAllOption.length; i++) {
                var vQuestionOption = listAllOption[i];

                if (parseInt(vQuestionOption.isRightAnswer) === 1) {
                  vCount += 1;
                }
              }

              if (1 === vCount) {
                // let dpAnswer = document.getElementById("dp_answer");
                // dpAnswer.style.backgroundColor = 'transparent';
                let listError = document.getElementsByClassName('answer_error');

                for (let j = 0; j < listError.length; j++) {
                  var vError = listError[j];
                  vError.style.display = "none";
                }

                let listJob = document.getElementsByClassName('cl_right_job');

                if (listJob != null && listJob.length > 0) {
                  let vJob = listJob[0];
                  vJob.style.display = '';
                }

                // 下一步
                window.successNextQuestionTip(hasOptionAudio);
                window.clearGuideTimeout();
              }

              // 改变选项位置
              document.getElementById('dp_reset_option_place').click();
            } else {
              oDiv.style.width = optionWidth + 'px';
              oDiv.style.height = optionHeight + 'px';
              oDiv.style.left = optionPadding + 'px';
              oDiv.style.top = oldTop + 'px';
            }

            document.ontouchmove = null;
            document.ontouchend = null;
          };
        };
      }
    }
);

// 归类题
Vue.directive('drag2',//自定义指令，多归类
    {
      bind:function (el, binding) {
        let oDiv = el;   // 当前元素
        let oldLeft = 0; // 选项图左边位置
        let oldTop = 0; // 选项图顶部位置
        let lastLeft = 0; // 拖拽后左边位置
        let lastTop = 0; // 拖拽后顶部位置

        let tmpRangeWidth = 0;
        let tmpRangeHeight = 0;
        let tmpRangeX = 0;
        let tmpRangeY = 0;

        // 计算答案位置，需要知道大图宽，总分类数组，选项数组
        let bgWidth = parseInt(binding.value.bgWidth);
        let listOption = JSON.parse(binding.value.optionJson);

        for (var i = 0; i < listOption.length; i++) {
          let vOption = listOption[i];
          if (vOption.isRightAnswer === 1) {
            tmpRangeWidth = vOption.rangeWidthOrRadius;
            tmpRangeHeight = vOption.rangeHeight;
            tmpRangeX = vOption.coordinateX;
            tmpRangeY = vOption.coordinateY;
          }
        }

        let oldWidth = parseInt(binding.value.optionWidth); // 选项图宽高
        oldLeft = oDiv.offsetLeft;
        oldTop = oDiv.offsetTop;

        oDiv.ontouchstart = function (e) {
          window.resetShowGuide();

          let inputClAnswer = document.getElementById('input_cl_answer');
          let tempClassify = inputClAnswer.value;
          let listClassify = [];

          // 隐藏框有值取隐藏框的值
          if (tempClassify.length > 0) {
            listClassify = JSON.parse(tempClassify);
          } else {
            listClassify = JSON.parse(binding.value.classifyJson);
          }

          let imgQuestion = document.getElementById('cl_question');
          let scale = imgQuestion.width / bgWidth;
          let imgId = parseInt(oDiv.id.replace(/cl_drag_/, ""));
          let objOption = listOption[imgId];

          // 获取同类总正确答案，当前已选择答案数
          var totalCount = 0; // 总正确答案数
          var currentCount = 0; // 已选择正确答案数

          for (var i = 0; i < listClassify.length; i++) {
            let objClassify = listClassify[i];
            totalCount = objClassify.totalCount;

            if (objClassify.x === objOption.coordinateX && objClassify.y === objOption.coordinateY) {
              currentCount = objClassify.currentCount;
              break;
            }
          }

          // 计算当前分类答案大小
          let isError = objOption.isRightAnswer === 0;
          let rangeWidthOrRadius = isError ? tmpRangeWidth * scale : parseInt(objOption.rangeWidthOrRadius) * scale; // 篮子宽
          let rangeHeight = isError ? tmpRangeHeight * scale : parseInt(objOption.rangeHeight) * scale; // 篮子高
          let answerRangeX = isError ? tmpRangeX * scale : objOption.coordinateX * scale; // 答案落选区域x坐标
          let answerRangeY = isError ? tmpRangeY * scale : objOption.coordinateY * scale; // 答案落选区域y坐标
          let answerRangeWidth = rangeWidthOrRadius / 2; // 答案落选区域宽
          let answerRangeHeight = rangeHeight; // 答案落选区域高
          let factWidth = Math.min(answerRangeWidth, answerRangeHeight); // 答案实际宽高
          let factX, factY; // 答案实际展示的x，y坐标

          if (totalCount > 2) {
            // 平分成两行的N份
            let totalColumn = Math.ceil(totalCount/2.0);
            answerRangeWidth = rangeWidthOrRadius/totalColumn;
            answerRangeHeight = rangeHeight/2;
            factWidth = Math.min(answerRangeWidth, answerRangeHeight);
            // 区域原点x+已展示答案数宽度+单个偏移位置
            factX = answerRangeX + currentCount%totalColumn*answerRangeWidth + (answerRangeWidth - factWidth)/2;
            // 区域原点y+(第一行是0或第二行答案高度)+单个偏移位置
            factY = (currentCount >= totalColumn ? answerRangeHeight : 0) + (answerRangeHeight - factWidth)/2;
          } else {
            // 区域原点x+已展示答案数宽度+单个偏移位置
            factX = answerRangeX + currentCount*answerRangeWidth + (answerRangeWidth - factWidth)/2;
            factY = (answerRangeHeight - factWidth)/2;
          }

          factX += imgQuestion.offsetLeft;
          factY += imgQuestion.offsetTop;

          oDiv.style.width = factWidth + 'px';
          oDiv.style.height = factWidth + 'px';

          let inputQuestionAnswer = document.getElementById('input_cl_question_answer');
          let tempIds = inputQuestionAnswer.value;
          let tempIdsArray = [];

          if (tempIds.length > 0) {
            tempIdsArray = JSON.parse(tempIds);
          }

          if (tempIdsArray.indexOf(imgId) !== -1) {
            return;
          }

          if (oldLeft === 0 && oldTop === 0) {
            oldLeft = oDiv.offsetLeft;
            oldTop = oDiv.offsetTop;
          }

          //鼠标按下，计算当前元素距离可视区的距离
          let disX = e.touches[0].clientY - oDiv.offsetLeft;
          let disY = e.touches[0].clientX + oDiv.offsetTop;

          document.ontouchmove = function (e) {
            //通过事件委托，计算移动的距离
            lastLeft = e.touches[0].clientY - disX;
            lastTop = disY - e.touches[0].clientX;

            //移动当前元素
            oDiv.style.left = lastLeft + 'px';
            oDiv.style.top = lastTop + 'px';
          };

          document.ontouchend = function (e) {
            let divPrint = document.getElementById('print');

            let realLeft = imgQuestion.offsetLeft + answerRangeX;
            let realTop = divPrint.clientHeight*3/4 - imgQuestion.offsetTop - answerRangeY;

            let realMinLeft = realLeft;
            let realMinTop = -realTop;
            let realMaxLeft = realLeft + rangeWidthOrRadius;
            let realMaxTop = realMinTop + rangeHeight;
            let offset = Math.min(answerRangeWidth, answerRangeHeight);

            let isOver = objOption.isRightAnswer === 1 && Math.max(parseInt(realMinLeft), parseInt(lastLeft)) <= Math.min(parseInt(realMaxLeft), (parseInt(lastLeft) + parseInt(offset)))
                && Math.max(parseInt(realMinTop), parseInt(lastTop)) <= Math.min(parseInt(realMaxTop), (parseInt(lastTop) + parseInt(offset)));

            if (isOver) {
              oDiv.style.left = factX + 'px';
              oDiv.style.top = -(realTop - factY) + 'px';

              const pageAudio = document.getElementById('cl_musicMp3');
              pageAudio.src = "https://img.xiaohuasheng.cn/drag_result.mp3";
              pageAudio.play();

              setTimeout(() => {
                pageAudio.src = "https://img.xiaohuasheng.cn/" + objOption.audio;
                pageAudio.play();
              }, 500);

              if (tempIdsArray.indexOf(imgId) === -1) {
                tempIdsArray.push(imgId);
                inputQuestionAnswer.value = JSON.stringify(tempIdsArray);
              }

              // 当前分组数量加1
              for (var j = 0; j < listClassify.length; j++) {
                let objClassify = listClassify[j];

                if (objClassify.x === objOption.coordinateX && objClassify.y === objOption.coordinateY) {
                  objClassify.currentCount += 1;
                  Vue.set(listClassify, j, objClassify);
                }
              }

              inputClAnswer.value = JSON.stringify(listClassify);

              var vCount = 0;

              for (var i = 0; i < listOption.length; i++) {
                var vQuestionOption = listOption[i];

                if (parseInt(vQuestionOption.isRightAnswer) === 1) {
                  vCount += 1;
                }
              }

              if (tempIdsArray.length === vCount) {
                // let clAnswer = document.getElementById("cl_answer");
                // clAnswer.style.backgroundColor = 'transparent';
                let listJob = document.getElementsByClassName("cl_job");
                if (listJob != null && listJob.length > 0) {
                  let vJob = listJob[0];
                  vJob.style.display = '';
                }

                let listError = document.getElementsByClassName('answer_error');

                for (let j = 0; j < listError.length; j++) {
                  var vError = listError[j];
                  vError.style.display = "none";
                }

                // 下一步
                window.successGetStarToNext();
                window.clearGuideTimeout();
              }
            } else {
              oDiv.style.width = oldWidth + 'px';
              oDiv.style.height = oldWidth  + 'px';
              oDiv.style.left = oldLeft + 'px';
              oDiv.style.top = oldTop + 'px';
            }

            document.ontouchmove = null;
            document.ontouchend = null;
          };
        };
      }
    }
);

// 上下拖拽题
Vue.directive('drag3',//自定义指令
    {
      bind:function (el, binding) {
        let oDiv = el;   //当前元素
        let oldLeft = 0;
        let oldTop = 0;
        let lastLeft = 0;
        let lastTop = 0;
        let questionType = parseInt(binding.value.questionType);
        let optionWidth = parseInt(binding.value.optionWidth);
        let bgWidth = parseInt(binding.value.bgWidth);
        let listQuestionOption = JSON.parse(binding.value.json);
        let syncPlay = parseInt(binding.value.syncPlay);

        oDiv.ontouchstart = function (e) {
          window.resetShowGuide();

          let imgQuestion = document.getElementById('dpu_question');
          let scale = imgQuestion.width / bgWidth;
          let imgId = parseInt(oDiv.id.replace(/dpu_drag_/, ""));
          let objQuestionOption = listQuestionOption[imgId];
          let fillingType = parseInt(objQuestionOption.fillingType);
          let rangeWidthOrRadius = parseInt(objQuestionOption.rangeWidthOrRadius) * scale;
          let rangeHeight = parseInt(objQuestionOption.rangeHeight) * scale;
          let optionOrder = parseInt(objQuestionOption.optionOrder);

          // 填充类型（1圆形/2方形）
          if (fillingType === 1) {
            oDiv.style.width = (rangeWidthOrRadius*2) + 'px';
            oDiv.style.height = (rangeWidthOrRadius*2)  + 'px';
          } else if (fillingType === 0) {
            for (var i = 0; i < listQuestionOption.length; i++) {
              var vQuestionOption = listQuestionOption[i];

              if (parseInt(vQuestionOption.isRightAnswer) === 1) {
                let vRangeWidthOrRadius = parseInt(vQuestionOption.rangeWidthOrRadius) * scale;
                let vRangeHeight = parseInt(vQuestionOption.rangeHeight) * scale;

                oDiv.style.width = vRangeWidthOrRadius + 'px';
                oDiv.style.height = vRangeHeight + 'px';
                break;
              }
            }
          } else {
            oDiv.style.width = rangeWidthOrRadius + 'px';
            oDiv.style.height = rangeHeight + 'px';
          }

          let dpQuestionAnswer = document.getElementById('input_dpu_question_answer');
          let tempIds = dpQuestionAnswer.value;
          let tempIdsArray = [];

          if (tempIds.length > 0) {
            tempIdsArray = JSON.parse(tempIds);
          }

          if (tempIdsArray.indexOf(imgId) !== -1) {
            return;
          }

          if (oldLeft === 0 && oldTop === 0) {
            oldLeft = oDiv.offsetLeft;
            oldTop = oDiv.offsetTop;
          }

          //鼠标按下，计算当前元素距离可视区的距离
          let disX = e.touches[0].clientY - oDiv.offsetLeft;
          let disY = e.touches[0].clientX + oDiv.offsetTop;

          document.ontouchmove = function (e) {
            //通过事件委托，计算移动的距离
            lastLeft = e.touches[0].clientY - disX;
            lastTop = disY - e.touches[0].clientX;

            //移动当前元素
            oDiv.style.left = lastLeft + 'px';
            oDiv.style.top = lastTop + 'px';
          };
          document.ontouchend = function (e) {
            let divPrint = document.getElementById('print');
            let currentPointX = objQuestionOption.coordinateX * scale;
            let currentPointY = objQuestionOption.coordinateY * scale;

            let realLeft = imgQuestion.offsetLeft + currentPointX;
            let realTop = divPrint.clientHeight*3/4 - imgQuestion.offsetTop - currentPointY - 20;

            let realMinLeft = 0;
            let realMinTop = 0;
            let realMaxLeft = 0;
            let realMaxTop = 0;
            let isOver = false;

            // 填充类型（1圆形/2方形）
            if (fillingType == 1) {
              realMinLeft = realLeft - rangeWidthOrRadius;
              realMinTop = -(realTop + rangeWidthOrRadius);
              realMaxLeft = realLeft + rangeWidthOrRadius;
              realMaxTop = -(realTop - rangeWidthOrRadius);

              isOver = (parseInt(lastLeft) > parseInt(realMinLeft - rangeWidthOrRadius) && parseInt(lastLeft + 2*rangeWidthOrRadius) < parseInt(realMaxLeft + rangeWidthOrRadius))
                  && (parseInt(lastTop) > parseInt(realMinTop - rangeWidthOrRadius) && parseInt(lastTop + 2*rangeWidthOrRadius) < parseInt(realMaxTop + rangeWidthOrRadius));
            } else {
              realMinLeft = realLeft;
              realMinTop = -realTop;
              realMaxLeft = realLeft + rangeWidthOrRadius;
              realMaxTop = -(realTop - rangeHeight);

              isOver = Math.max(parseInt(realMinLeft), parseInt(lastLeft)) <= Math.min(parseInt(realMaxLeft), (parseInt(lastLeft) + parseInt(rangeWidthOrRadius)))
                  && Math.max(parseInt(realMinTop), parseInt(lastTop)) <= Math.min(parseInt(realMaxTop), (parseInt(lastTop) + parseInt(rangeHeight)));
            }

            document.getElementById('id_time_out').click();

            if (isOver) {
              // 顺序拖拽题(引导问号)
              if (questionType === 5) {
                window.showOrderQuestionTip(optionOrder + 1);
              }

              oDiv.style.left = realMinLeft + 'px';
              oDiv.style.top = realMinTop + 'px';
              window.dpuPlayEnded();

              let optioneAudio = "https://img.xiaohuasheng.cn/" + objQuestionOption.audio;
              let hasOptionAudio = objQuestionOption.audio != null && objQuestionOption.audio.length > 0;

              if (syncPlay !== 1) {
                const pageAudio = document.getElementById('dpu_musicMp3');
                pageAudio.src = "https://img.xiaohuasheng.cn/drag_result.mp3";
                pageAudio.play();

                oDiv.onclick = function () {
                  setTimeout(() => {
                    pageAudio.src = optioneAudio;
                    pageAudio.play();
                  }, 500);
                }

                oDiv.click();
              } else {
                // 播放音效
                window.play_Dpu_DragSound(optioneAudio);
              }

              if (tempIdsArray.indexOf(imgId) === -1) {
                tempIdsArray.push(imgId);
                dpQuestionAnswer.value = JSON.stringify(tempIdsArray);
              }

              // 判断是否完成题目
              var vCount = 0;

              for (var i = 0; i < listQuestionOption.length; i++) {
                var vQuestionOption = listQuestionOption[i];

                if (parseInt(vQuestionOption.isRightAnswer) === 1) {
                  vCount += 1;
                }
              }

              if (tempIdsArray.length === vCount) {
                let listJob = document.getElementsByClassName("cl_job");
                if (listJob != null && listJob.length > 0) {
                  let vJob = listJob[0];
                  vJob.style.display = '';
                }

                let listError = document.getElementsByClassName('answer_error');
                if (listError.length > 0) {
                  for (let j = 0; j < listError.length; j++) {
                    var vError = listError[j];
                    vError.style.display = "none";
                  }
                }

                if (syncPlay !== 1) {
                  // 下一步
                  window.successGetStarToNext();
                } else {
                  window.successNextQuestionTip(hasOptionAudio);
                }

                window.clearGuideTimeout();
              }
            } else {
              oDiv.style.width = optionWidth + 'px';
              oDiv.style.height = optionWidth  + 'px';
              oDiv.style.left = oldLeft + 'px';
              oDiv.style.rigth = 'auto';
              oDiv.style.top = oldTop + 'px';
            }

            document.ontouchmove = null;
            document.ontouchend = null;
          };
        };
      }
    }
);
Vue.prototype.removePageWordLocalStorage = function () {
  if (localStorage != null) {
    localStorage.removeItem('bfpageword_currentIndex');
    localStorage.removeItem('bfpageword_pageJson');
  }
};
Vue.prototype.removeChoicequestionLocalStorage = function () {
  if (localStorage != null) {
    localStorage.removeItem('bfchoicequestion_questionIndex');
    localStorage.removeItem('bfchoicequestion_questionJson');
  }
};

// 0-开发环境，1-正式环境
const environment = 1
Vue.prototype.$qiNiuDomainBase = environment == 1 ? "https://img.xiaohuasheng.cn/" : "http://testimg.xiaohuasheng.cn/"

// 全局组件
import customComponents from './custom-components.js'
Vue.use(customComponents);

new Vue({
  render: h => h(App),
  router,
  store,
  $,
}).$mount('#app')
